import { injectQuery } from '@tanstack/angular-query-experimental'
import metadata from './metadata'

// NOTE: This query returns static data, will see in the future if we need a fetch
export function injectMetadataQuery() {
  return injectQuery(() => ({
    queryKey: ['metadata'],
    queryFn: async () => {
      return Promise.resolve(metadata)
    },
  }))
}
